/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Management_TitleInputs */

const en_user_management_title = /** @type {(inputs: User_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User Management`)
};

const ja_user_management_title = /** @type {(inputs: User_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー管理`)
};

const fr_user_management_title = /** @type {(inputs: User_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestion des utilisateurs`)
};

const de_user_management_title = /** @type {(inputs: User_Management_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerverwaltung`)
};

/**
* | output |
* | --- |
* | "User Management" |
*
* @param {User_Management_TitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_management_title = /** @type {((inputs?: User_Management_TitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Management_TitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_management_title(inputs)
	if (locale === "ja") return ja_user_management_title(inputs)
	if (locale === "fr") return fr_user_management_title(inputs)
	return de_user_management_title(inputs)
});